module.exports = "/assets/data/155fe65b8ee98dcb7ffee22b1454b244-B25.data.json";